export const getExcludePages = (pagesConfig = {}) =>
  Object.keys(pagesConfig).reduce((excludePages, pageName) => {
    if (pagesConfig[pageName]?.exclude) {
      excludePages.push(pageName);
    }

    return excludePages;
  }, []);
